<div class="dialog-form-response">
  <!-- Header -->
  <header class="dialog-form-response__header">
    <div class="dialog-form-response__heading">
      <ui-atom-text type="title" [text]="data.title"></ui-atom-text>
      <ui-atom-text
        type="medium"
        [text]="data.formName"
        class="dialog-form-response__form-name"
      ></ui-atom-text>
    </div>
    <button
      type="button"
      class="dialog-form-response__expand"
      [attr.aria-label]="isExpanded ? 'Collapse dialog' : 'Expand dialog'"
      (click)="toggleExpanded()"
    >
      <mat-icon>{{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
  </header>

  <!-- Body con scroll único -->
  <main class="dialog-form-response__body">
    @if (availableLocales.length > 1) {
      <div class="dialog-form-response__locale-selector">
        <label for="form-response-locale-select">{{ 'publicForm.fill.language.label' | translate }}</label>
        <select
          id="form-response-locale-select"
          (change)="onLocaleChange($any($event.target).value)"
        >
          @for (locale of availableLocales; track locale.code) {
            <option [value]="locale.code" [selected]="locale.code === selectedLocale">
              {{ locale.label }}
            </option>
          }
        </select>
      </div>
    }

    @if (surveyModel) {
      <survey [model]="surveyModel"></survey>
    }
  </main>

  <!-- Footer · CTAs siempre visibles -->
  <footer class="dialog-form-response__footer">
    @if (isCompleted) {
      <ui-atom-button
        type="button"
        rules="main"
        styling="filled"
        [withShadow]="true"
        [text]="'common.close' | translate"
        (buttonClick)="attemptClose()"
      >
      </ui-atom-button>
    } @else if (!isViewMode) {
      <ui-atom-button
        type="button"
        rules="main"
        styling="outlined"
        [withShadow]="false"
        [text]="'common.close' | translate"
        [disabled]="isSaving || isSubmitting"
        (buttonClick)="attemptClose()"
      >
      </ui-atom-button>

      <ui-atom-button
        type="button"
        rules="main"
        styling="outlined"
        [withShadow]="false"
        [text]="'publicForm.fill.buttons.save' | translate"
        [disabled]="isSaving || isSubmitting"
        (buttonClick)="onSave()"
      >
      </ui-atom-button>

      <ui-atom-button
        type="button"
        rules="main"
        styling="filled"
        [withShadow]="true"
        [text]="'publicForm.fill.buttons.submit' | translate"
        [disabled]="!hasSaved || isSaving || isSubmitting"
        (buttonClick)="onSubmit()"
      >
      </ui-atom-button>
    } @else {
      <ui-atom-button
        type="button"
        rules="main"
        styling="outlined"
        [withShadow]="false"
        [text]="'common.close' | translate"
        (buttonClick)="attemptClose()"
      >
      </ui-atom-button>

      @if (canDownloadPdf) {
        <ui-atom-button
          type="button"
          rules="main"
          styling="filled"
          [withShadow]="true"
          [text]="'forms.response.buttons.downloadPdf' | translate"
          [disabled]="isDownloadingPdf"
          (buttonClick)="onDownloadPdf()"
        >
        </ui-atom-button>
      }
    }
  </footer>
</div>
